import React from 'react'

interface Props {
  price: string | null
}

const FormattedPrice = ({ price }: Props): JSX.Element | null => {
  if (!price) {
    return <div style={{ whiteSpace: 'break-spaces' }}> </div>
  } else {
    const formattedNumber =
      Number(price) % 1 === 0 ? Number(price) : Number(price).toFixed(2)
    return <>{`$${formattedNumber.toString()}`}</>
  }
}

export default FormattedPrice
